import { useCallbackEvent } from '@dni-react-hooks/use-callback-event'
import { AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { ORDER_CANCEL_METHOD, type OrderPlatformType } from '../types/order-events'
import { useAnalytics } from './useAnalytics'

interface UseOrderAnalyticsEventProps {
  userId: string
  platform: OrderPlatformType
}

export const useOrderAnalyticsEvent = (props: UseOrderAnalyticsEventProps) => {
  const { userId, platform } = props
  const { sendEvent } = useAnalytics({ defaultPlatforms: [AnalyticsPlatforms.GA4] })

  const sendOrderReorderClickEvent = useCallbackEvent((params: {
    orderId: string
    statusTab: string
  }) => {
    if (!userId) return
    sendEvent({
      eventName: 'order_reorder_click',
      eventParams: {
        event_category: 'order_reorder_click',
        order_id: params.orderId,
        status_tab: params.statusTab,
        user_id: userId,
        platform,
      },
    })
  })

  const sendOrderCancelClickEvent = useCallbackEvent((params: {
    orderId: string
    transactionId: string
    pageSource: string
  }) => {
    if (!userId) return
    sendEvent({
      eventName: 'order_cancel_click',
      eventParams: {
        event_category: 'order_cancel_click',
        order_id: params.orderId,
        transaction_id: params.transactionId,
        page_source: params.pageSource,
        user_id: userId,
        platform,
      },
    })
  })

  const sendOrderCancelSuccessEvent = useCallbackEvent((params: {
    orderId: string
    transactionId: string
  }) => {
    if (!userId) return
    sendEvent({
      eventName: 'order_cancel_success',
      eventId: params.transactionId,
      eventParams: {
        event_category: 'order_cancel_success',
        order_id: params.orderId,
        transaction_id: params.transactionId,
        cancel_method: ORDER_CANCEL_METHOD.MANUAL,
        user_id: userId,
        platform,
      },
    })
  })

  return {
    sendOrderReorderClickEvent,
    sendOrderCancelClickEvent,
    sendOrderCancelSuccessEvent,
  }
}
